<script>
    let { method, onLoading } = $props();

    import { auth, safeSignOut } from "@services/firebase";
    import {
        signInWithEmailAndPassword,
        createUserWithEmailAndPassword,
    } from "firebase/auth";
    import { goTo } from "@utils/router";
    import { createUserIfNoExists } from "@services/common";
    import { translate } from "@/utils/format";
    import appStore from "@/utils/store";
    import { CalooAdminConfig } from "@/services/admin";

    let email = $state("");
    let password = $state("");
    let confirmPassword = $state("");
    let fullName = $state("");
    let acceptTerms = $state(true);
    let errorMessage = $state("");

    async function signUp() {
        errorMessage = "";

        // Validaciones previas
        if (!email || !password) {
            errorMessage = translate(
                "ERROR_REQUIRED_FIELDS",
                "Todos los campos son obligatorios.",
            );
            return;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            errorMessage = translate(
                "ERROR_INVALID_EMAIL",
                "El email no es válido.",
            );
            return;
        }
        if (password.length < 6) {
            errorMessage = translate(
                "ERROR_PASSWORD_MIN",
                "La contraseña debe tener al menos 6 caracteres.",
            );
            return;
        }
        if (method === "signin" && password !== confirmPassword) {
            errorMessage = translate(
                "ERROR_PASSWORD_MATCH",
                "Las contraseñas no coinciden.",
            );
            return;
        }
        if (!acceptTerms) {
            errorMessage = translate(
                "ERROR_ACCEPT_TERMS",
                "Debes aceptar los términos de uso.",
            );
            return;
        }

        onLoading(true);

        try {
            if (method === "signin") {
                const result = await createUserWithEmailAndPassword(
                    auth,
                    email,
                    password,
                );
                await createUserIfNoExists(result.user, false, fullName);
                goTo("/dashboard");
                // goTo("/dashboard");
            } else {
                const result = await signInWithEmailAndPassword(
                    auth,
                    email,
                    password,
                );
                await createUserIfNoExists(result.user);
            }
        } catch (error) {
            const code = error?.code;
            console.error("❌ Firebase auth error:", code);

            if (code === "auth/email-already-in-use") {
                errorMessage = translate(
                    "ERROR_EMAIL_IN_USE",
                    "Este correo electrónico ya está registrado.",
                );
            } else if (code === "auth/user-not-found") {
                errorMessage = translate(
                    "ERROR_USER_NOT_FOUND",
                    "Este usuario no existe.",
                );
            } else if (code === "auth/wrong-password") {
                errorMessage = translate(
                    "ERROR_WRONG_PASSWORD",
                    "Contraseña incorrecta.",
                );
            } else if (code === "auth/invalid-email") {
                errorMessage = translate(
                    "ERROR_INVALID_EMAIL",
                    "Correo electrónico no válido.",
                );
            } else {
                errorMessage = translate(
                    "ERROR_GENERIC",
                    "Ha ocurrido un error. Inténtalo de nuevo.",
                );
                console.warn("⚠️ Redirigiendo a logout por error grave:", code);
                await safeSignOut();
                goTo("/logout", { cause: "firebase_error", errorCode: code });
            }
        } finally {
            onLoading(false);
        }
    }
</script>

<div class="emailAndPwd">
    {#if method === "signin"}
        <input
            type="text"
            placeholder={translate("PLACEHOLDER_FULLNAME", "Nombre completo")}
            bind:value={fullName}
        />
    {/if}

    <input
        type="text"
        placeholder={translate("PLACEHOLDER_EMAIL", "Email")}
        bind:value={email}
    />

    <input
        type="password"
        placeholder={translate("PLACEHOLDER_PASSWORD", "Contraseña")}
        bind:value={password}
    />

    {#if method === "signin"}
        <input
            type="password"
            placeholder={translate(
                "PLACEHOLDER_CONFIRM_PASSWORD",
                "Confirmar contraseña",
            )}
            bind:value={confirmPassword}
        />
    {/if}

    {#if method === "signin"}
        <div class="termsContainer">
            <label class="terms">
                <input type="checkbox" bind:checked={acceptTerms} />
                <span>
                    {translate("LABEL_ACCEPT_TERMS", "Acepto los")}
                    <a
                        href="https://www.caloo.app/terms-and-conditions"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {translate(
                            "LABEL_TERMS",
                            "Términos y la Política de Privacidad",
                        )}
                    </a>
                </span>
            </label>
        </div>
    {/if}

    {#if errorMessage}
        <p class="error">{errorMessage}</p>
    {/if}
    {#if method === "signin"}
        <button onclick={signUp}>
            {translate("BUTTON_SUBMIT", "Registrarse")}
        </button>
    {:else}
        <button onclick={signUp}>
            {translate("BUTTON_SUBMIT", "Iniciar sesión")}
        </button>
    {/if}
</div>

<style lang="scss">
    @use "./styles/index.scss";
</style>
